import styled from "styled-components";
import { device } from "../../../stylesheet/breakpoints";

export const Container = styled.div`
  width: 100%;
  text-align: start;

  @media ${device.desktop} {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: calc(100% - 200px);
  }
`;

export const Loader = styled.div`
  margin-right: 10px;
  font-weight: 700;
  font-size: 10px;
  line-height: 1.2;
  color: var(--text-color);
`;

export const LoaderFrom = styled(Loader)`
  font-weight: 300;
`;

export const ProgressPrev = styled.div`
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 10px;
  padding-block: 3px;
  border-radius: 50%;
  background-color: var(--article-bg);
  text-align: center;
  font-weight: 400;
  font-size: 10px;
  line-height: 1.2;
  color: var(--text-color);
`;

export const ProgressBar = styled(ProgressPrev)`
  background-color: var(--bg-button);
  color: var(--white);
`;
